import { MARGINS_BLOCKS } from '@features/cms/const';
import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const verticalPositions = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};
const horizontalPositions = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
export default {
  styledSection: (bg = 'transparent', mt = 0, mb = 0) => ({
    bg,
    mt: MARGINS_BLOCKS[mt],
    mb: MARGINS_BLOCKS[mb],
    height: '120vh',
    width: '100%',
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 0
  }),
  styledStickyContainer: {
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh'
  },
  slide: (opacity: number) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    ...reusables.mainTransition('opacity', theme.transitions.animation.atomCurve, theme.transitions.time.long),
    opacity
  }),
  sliderNavigationBox: {
    position: 'absolute',
    top: 0,
    height: [56, 56, 56, 100],
    left: [0, 0, 0, '10.15625vw'],
    zIndex: theme.zIndex.documentHigh,
    display: 'flex',
    alignItems: 'center'
  },
  styledPromoText: {
    transform: 'rotate(90deg) translate(30%, -100%)',
    position: 'absolute',
    top: [96, 96, 120, 116],
    right: ['10px', '10px', '10px', 24],
    zIndex: theme.zIndex.documentHigh
  },
  navContainer: {
    background: 'linear-gradient(180deg, rgba(25, 25, 25, 0.20) 0%, rgba(25, 25, 25, 0.00) 100%)',
    backgroundBlendMode: 'multiply',
    position: 'relative'
  },
  navButtons: {
    '&.keen-slider__slide': {
      background: 'transparent',
      overflow: 'visible !important',
      width: 'min-content !important',
      border: 'none',
      minHeight: 'auto !important',
      '&.active': {
        h6: {
          borderBottom: `1px solid ${theme.rawColors.neutralWhite}`
        }
      },
      '&:hover': {
        h6: {
          borderBottom: `1px solid ${theme.rawColors.neutralWhite}`
        }
      },
      h6: {
        width: 'max-content',
        borderBottom: `1px solid transparent`,
        ...reusables.mainTransition('border-color')
      },
      '&:first-of-type': {
        ml: [40, 40, 64, 0]
      },
      '&:last-of-type': {
        pr: 100
      }
    }
  },
  contentContainer: (vp: 'top' | 'center' | 'bottom', hp: 'left' | 'center' | 'right') => ({
    position: 'absolute',
    left: ['10.6666667vw', '10.6666667vw', '8.33333333vw', '10.15625vw'],
    right: ['10.6666667vw', '10.6666667vw', '8.33333333vw', '10.15625vw'],
    bottom: [64, 64, 80, '6.04166667vw'],
    height: ['97.3333333vw', '97.3333333vw', '67.6432292vw', '24.9739583vw'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: verticalPositions[vp],
    alignItems: horizontalPositions[hp],
    zIndex: theme.zIndex.documentHigh,
    textAlign: hp,
    'h2,h1': {
      maxWidth: 900
    }
  })
};